<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99996 13.3333V9.33331"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33329 10.6667L7.99996 9.33334L6.66663 10.6667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 13.3333H12.6667C13.0203 13.3334 13.3595 13.193 13.6096 12.9429C13.8597 12.6928 14.0001 12.3536 14 12V5.95999C14 5.22362 13.403 4.62669 12.6667 4.62666H8.35267C8.13187 4.62665 7.9254 4.5173 7.80133 4.33466L6.86467 2.95799C6.74059 2.77578 6.53444 2.66671 6.314 2.66666H3.33333C2.97968 2.66656 2.64049 2.807 2.39042 3.05707C2.14035 3.30714 1.9999 3.64634 2 3.99999V12C1.9999 12.3536 2.14035 12.6928 2.39042 12.9429C2.64049 13.193 2.97968 13.3334 3.33333 13.3333H5.33333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
